import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksCalculationVolumeMetrics: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRICS,
	},
	getDoneWorksCalculationVolumeMetricPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_PREVIEW,
	},
	getDoneWorksCalculationVolumeMetricPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_POPUP,
	},
	createDoneWorksCalculationVolumeMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].CREATE_DONE_WORKS_CALCULATION_VOLUME_METRIC,
	},
	getDoneWorksCalculationVolumeMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].GET_DONE_WORKS_CALCULATION_VOLUME_METRIC,
	},
	patchDoneWorksCalculationVolumeMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC,
	},
	patchDoneWorksCalculationVolumeMetricIntervals: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_INTERVALS,
	},
	patchDoneWorksCalculationVolumeMetricBulkUpdate: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_BULK_UPDATE,
	},
	putDoneWorksCalculationVolumeMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].PUT_DONE_WORKS_CALCULATION_VOLUME_METRIC,
	},
	deleteDoneWorksCalculationVolumeMetric: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS].DELETE_DONE_WORKS_CALCULATION_VOLUME_METRIC,
	},
}